import { render, staticRenderFns } from "./PagamentosExtras.vue?vue&type=template&id=077b51f5&"
import script from "./PagamentosExtras.vue?vue&type=script&lang=js&"
export * from "./PagamentosExtras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports